module.exports = __webpack_public_path__ + "static/media/lwazi-large-text.4b818eac.png";